<h2 mat-dialog-title style="text-align: center; font-size: x-large;">{{'D_T3' | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <div style="text-align: -webkit-center;text-align: -moz-center;">
        <mat-spinner diameter="20"></mat-spinner>
    </div>
</mat-dialog-content>
